import {t} from '@lingui/macro'

import type {ButtonProps} from '@pleo-io/telescope'
import {Button} from '@pleo-io/telescope'

import {useSupportChat} from '@product-web/external/use-support-chat'

export function ContactSupport({
    onClick,
    isDisabled,
    className,
    chatLabel,
    emailSubject,
    emailBody,
    emailLabel,
    buttonVariant = 'link',
    ...buttonProps
}: {
    isDisabled?: boolean
    onClick?: () => void
    className?: string
    chatLabel?: string
    emailBody?: string
    emailSubject?: string
    emailLabel?: string
    buttonVariant?: ButtonProps['variant']
} & Omit<ButtonProps, 'variant'>) {
    const supportChat = useSupportChat()
    const canLiveChat = supportChat.isConnected && supportChat.isEntitled
    return (
        <>
            {canLiveChat && (
                <Button
                    {...buttonProps}
                    disabled={isDisabled}
                    className={className}
                    variant={buttonVariant ?? 'link'}
                    onClick={() => {
                        supportChat.show()
                        onClick?.()
                    }}
                >
                    {chatLabel ?? t`Chat with us`}
                </Button>
            )}
            {!canLiveChat && (
                <Button
                    {...buttonProps}
                    disabled={isDisabled}
                    className={className}
                    href={getEmailHref({emailBody, emailSubject})}
                    variant={buttonVariant}
                    onClick={() => {
                        onClick?.()
                    }}
                >
                    {emailLabel ?? t`Contact support@pleo.io`}
                </Button>
            )}
        </>
    )
}

type GetEmailHrefArgs = {
    emailBody?: string
    emailSubject?: string
}

const getEmailHref = ({emailBody, emailSubject}: GetEmailHrefArgs): string => {
    const url = new URL('mailto:support@pleo.io')

    if (emailSubject) {
        url.searchParams.append('subject', emailSubject)
    }

    if (emailBody) {
        url.searchParams.append('body', emailBody)
    }

    return url.href
}
